import composer, { type optionPairType } from "./composer";

export default (option: optionPairType) =>
  composer(option, "numberInput", {
    fieldLabel: "Listed Order (Template List)",
    fieldValue: "0",
  });
